














import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { Base } from '@/base'

@Component({
  name: 'IndicatorComponent'
})
export default class IndicatorComponent extends Base {
  @Prop( {default: () => ({})} ) info;
  @Prop({default: ''}) className;
};
